import BaseModelAPI from '../BaseModelAPI';
import ModuleInfo from './ModuleInfo';

export default class FunctionInfoAPI extends BaseModelAPI {
  static entity = 'functioninfo'
  static entityName = "functioninfo";
  constructor(){

    /*APP_MODEL_DEFINITION*/
        this.id = '';
        this.name = '';
        this.uri = '';
        this.iconName = '';
        this.isEnabled = false;
        this.moduleInfoId = '';
        this.moduleInfo = {};
        
    /*END_APP_MODEL_DEFINITION*/
    }
}